"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _progress = _interopRequireDefault(require("@clds/progress"));
var _componentEnhancer = require("@clds/component-enhancer");
var _props = require("../props");
var _StyledBaseButton = require("./StyledBaseButton");
var _StyledProgress = require("./StyledProgress");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BaseButton = (0, _styledComponents.default)(_StyledBaseButton.StyledBaseButton).attrs(props => {
  const {
    size,
    progress,
    children,
    className,
    disabled,
    selected
  } = props;
  return {
    children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, progress && /*#__PURE__*/_react.default.createElement(_StyledProgress.StyledProgress, null, /*#__PURE__*/_react.default.createElement(_progress.default.Circular, {
      size: size === 'sm' ? 'xs' : 'md'
    })), /*#__PURE__*/_react.default.createElement(_componentEnhancer.WrapTextChildren, null, children)),
    className: (0, _classnames.default)(className, {
      progress,
      disabled,
      selected
    })
  };
}).withConfig({
  displayName: "BaseButton"
})([""]);
exports.BaseButton = BaseButton;
BaseButton.propTypes = _props.propTypes;
BaseButton.defaultProps = _props.defaultProps;
//# sourceMappingURL=BaseButton.js.map